<template>
  <el-dialog title="请选择专业" :visible.sync="dialogVisible" width="30%">
    <span class="p-l">
      <enum-select
        placeholder="请选择专业"
        v-model="userData"
        :options="userBak"
        value-key="specialtyId"
        id="Object"
        label="specialtyName"
      ></enum-select>
    </span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
      <el-button type="primary" @click="save" size="mini">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import store from "@/store";
import {mapState} from "vuex"

export default {
  props: {},
  mounted() {
  },
  data() {
    return {
      dialogVisible: false,
      cb: undefined,
      userData: store.state.user.regInfo
    };
  },
  computed: {
    ...mapState(['userBak'])
  },
  methods: {
    open(cb, isUserData) {
      if (isUserData) {
        this.userData = undefined;
      }
      this.dialogVisible = true;
      this.cb = cb;
    },
    save() {
      if (!this.userData) {
        this.$message.error("请选择专业");
        return;
      }
      this.axios.get("/student/chooseSpeciality", {
        params: {
          registerinfoId: this.userData.registerinfoId
        },
      });
      this.cb && this.cb(this.userData);
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.p-l {
  padding-left: 10px;
}
</style>
